module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"download_discount":"Скачать скидки"},"en":{"download_discount":"Download discounts"}}')
  delete Component.options._Ctor
}
